import Highcharts from 'highcharts'
import type { Options as HighchartsOptions } from 'highcharts'
import { i18n } from '@/i18n'

// Highcharts 的全局配置选项类型
export const HighchartsConfig = (): void => {
	const options: HighchartsOptions = {
		lang: {
			resetZoom: i18n.global.t('framework.chart.resetZoom'),
			noData: i18n.global.t('charts.noData'), // 自定义无数据时的提示文本
			lang: {
				dragDrop: {
					drag: i18n.global.t('framework.chart.drag')
				}
			}
		},
		global: { useUTC: false },
		noData: {
			style: {
				fontWeight: 'bold',
				fontSize: '15px',
				color: '#95AFBD'
			}
		},

		colors: [
			'#33FFCC', // 青色
			'#FF5733', // 橙色
			'#33FF57', // 绿色
			'#3366FF', // 蓝色
			'#FF33EE', // 紫色
			'#33FFFF', // 青色
			'#FF3366', // 红色
			'#FFFF33', // 黄色
			'#3399FF', // 蓝色
			'#33FF99', // 绿色
			'#9933FF', // 紫色
			'#FF9933' // 橙色
		]
	}

	Highcharts.setOptions(options)
}
